const HalfSpace = () => <span style={{ fontSize: ".5em" }}>&nbsp;</span>;

export default HalfSpace;
